
import {createComponentSimulation} from '@wixc3/simulation-core';
import {StylableButton} from '../../StylableButton';

export default createComponentSimulation({
  componentType: StylableButton,
  name: 'StylableButtonPreset20',
  readOnly: true,
  props: {
    label: 'stylable_button_preset_addApp',
    svgId: '11062b_79e95670a63d4a15bfd0750934e7852a.svg',
  },
});
